/** Browser event when a new offline service worker is ready but the page still runs the old shell. */
export const OFFLINE_SW_UPDATE_AVAILABLE_EVENT = 'bono:offline-sw-update-available' as const;

export const OFFLINE_SW_UPDATE_PENDING_SESSION_KEY = 'bono_offline_sw_update_pending';

export function isOfflineServiceWorkerUpdatePending(): boolean {
  try {
    return globalThis.sessionStorage.getItem(OFFLINE_SW_UPDATE_PENDING_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function markOfflineServiceWorkerUpdatePending(): void {
  try {
    globalThis.sessionStorage.setItem(OFFLINE_SW_UPDATE_PENDING_SESSION_KEY, '1');
  } catch {
    /* sessionStorage unavailable */
  }
}

export function clearOfflineServiceWorkerUpdatePending(): void {
  try {
    globalThis.sessionStorage.removeItem(OFFLINE_SW_UPDATE_PENDING_SESSION_KEY);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function dispatchOfflineServiceWorkerUpdateAvailable(): void {
  markOfflineServiceWorkerUpdatePending();
  globalThis.dispatchEvent(new CustomEvent(OFFLINE_SW_UPDATE_AVAILABLE_EVENT));
}

/** True when an installing worker should surface the update banner (not first SW install). */
export function shouldAnnounceOfflineServiceWorkerUpdate(hasActiveController: boolean): boolean {
  return hasActiveController;
}
